import { render, staticRenderFns } from "./ObjectsUploadFile.vue?vue&type=template&id=aafc9148&"
import script from "./ObjectsUploadFile.vue?vue&type=script&lang=js&"
export * from "./ObjectsUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./ObjectsUploadFile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports